module.exports = __webpack_public_path__ + "static/full1-4de6face7a4904fe4681bd7bfea62614.png";